import React from 'react';
import { useGetSkuListQuery } from '../../../screens/Detail/apiDetail';
import { Spinner } from '@ydistri/ds';
import { addToast } from '@ydistri/utils';
import SKUTableComponent from './SKUTableComponent';
import { useCurrency } from '../../../hooks/useCurrency';
import { NO_VALUE } from '../../../lib/utils/utilsTypes';
import { useAppDispatch } from '../../../store';

interface SKUTableComponentProps {
  productId?: number;
  storeId?: number;
  loadingSalesData?: boolean;
}

const SKUTableController: React.FC<SKUTableComponentProps> = ({
  productId = NO_VALUE,
  storeId = NO_VALUE,
}) => {
  const dispatch = useAppDispatch();
  const { data, isFetching, isError } = useGetSkuListQuery({ productId, storeId });
  const currency = useCurrency();

  if (isError) {
    dispatch(addToast({ message: 'Unable to load SKUs', isError: true }));
    return;
  }

  if (isFetching) {
    return <Spinner />;
  }

  if (data) {
    return <SKUTableComponent data={data.data} currency={currency} />;
  }
};

export default SKUTableController;
